import React from 'react';
import LAppFullscreenBackground from '../../app/layouts/LAppFullscreenBackground';
import { AppLogoTextWhite } from '../../app/features/logo/AppLogo';
import { Container, Box, Fab, Stack } from '@mui/material';
import PAuthLogin from './pages/PAuthLogin';
import CAppTooltip from '../../app/components/CAppTooltip';
import langAuthLogin from './features/login/langs/langAuthLogin';
import AppCustomIcon from '../../app/features/icon/AppIcon';
import HAppRoutes from '../../app/features/routes/helpers/HAppRoutes';
import FaqRoutes from '../faq/FaqRoutes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PAuthPasswordForgot from './pages/PAuthPasswordForgot';
import PAuthInvestorResetPassword from './pages/PAuthInvestorResetPassword';
import { Link } from 'react-router-dom';
import PAuthInvestorUserActivation from './pages/PAuthInvestorUserActivation';
import AppLangSelect from '../../app/features/lang/features/select/AppLangSelect';
import { globalConfig } from '../../app/config/config';
type InvestorProps = {
	page: string;
};
const Auth = (props: InvestorProps) => {
	const { page } = props;

	const navigate = useNavigate();
	const { t } = useTranslation();

	const renderContent = () => {
		switch (page) {
			default:
			case 'login':
				return <PAuthLogin />;
			case 'password-forgot':
				return <PAuthPasswordForgot />;
			case 'investor-reset-password':
				return <PAuthInvestorResetPassword />;
			case 'investor-user-activation':
				return <PAuthInvestorUserActivation />;
		}
	};

	return (
		<LAppFullscreenBackground>
			<div style={{ width: '100%', textAlign: 'left', padding: '30px' }}>
				<Link to="/">
					<AppLogoTextWhite style={{ height: '60px' }} />
				</Link>
			</div>
			<Container>
				<Stack
					style={{ height: 'calc(100vh - 110px)', width: '100%' }}
					alignItems="center"
					justifyContent="center"
				>
					<Box sx={{ width: '100%' }}>{renderContent()}</Box>
					<Box
						style={{
							width: '100%',
							textAlign: 'center',
							marginTop: '30px',
							color: 'white',
							fontSize: '0.85rem',
						}}
					>
						<CAppTooltip title={t(langAuthLogin.btn_faq.tag)}>
							<Box>
								<Fab
									color="secondary"
									aria-label="add"
									onClick={() => navigate(HAppRoutes.getPath(FaqRoutes.faq.tag))}
								>
									<AppCustomIcon tag="question" />
								</Fab>
							</Box>
						</CAppTooltip>
					</Box>
				</Stack>
			</Container>
			<Box
				style={{
					width: 'auto',
					textAlign: 'left',
					padding: '15px 30px',
					position: 'absolute',
					bottom: 0,
					left: 0,
					visibility: 'hidden',
					color: 'white',
					fontSize: '0.85rem',
				}}
			>
				Sienna investors portal V{globalConfig.get().APP_VERSION}
			</Box>
			<Box
				style={{
					width: 'auto',
					textAlign: 'right',
					padding: '15px 30px',
					position: 'absolute',
					top: 0,
					right: 0,
					color: 'white',
					fontSize: '0.85rem',
				}}
			>
				<AppLangSelect style={{ color: '#FFF' }} />
			</Box>
		</LAppFullscreenBackground>
	);
};

export default Auth;
